document.addEventListener("DOMContentLoaded", (event) => {
    let item_edit_buttons = document.querySelectorAll('.js-item-edit');
    
    item_edit_buttons.forEach((item_edit_button) => {
        item_edit_button.addEventListener('click', function(e){
            e.preventDefault();

            let customily_preview_image = e.currentTarget.closest('.cart-item').querySelector('.cart-item__image').src,
                customily_customization_url = e.currentTarget.dataset.product,
                line_item_id = e.currentTarget.dataset.lineItemId;

            document.querySelector('.js-edit-product-image').src = customily_preview_image;
            document.querySelector('.js-edit-product-link').href = customily_customization_url;
            document.querySelector('.js-edit-product-link').dataset.lineItemId = line_item_id;

            document.querySelector('.edit-product').classList.add('is-open');
        });
    });

    let item_close_buttons = document.querySelectorAll('.js-item-close');
    item_close_buttons.forEach((item_close_button) => {
        item_close_button.addEventListener('click', function(e){
            console.log('close');
            document.querySelector('.edit-product').classList.remove('is-open');
        });
    });
});